// extracted by mini-css-extract-plugin
export default {"title":"DownloadFileButton_title__lCrdH","newLabel":"DownloadFileButton_newLabel__99ybq"};